import attachableCategoryApi from "~/api/attachable_category";
import attachableApi from "~/api/attachable";
import isAttachableApi from "~/api/isAttachable";

const deleteSelected = ({ getters, dispatch }) => {
  attachableApi.deleteAll(getters.selectedFromActiveCategory.map((selected) => selected.id), true)
    .then(() => {
      dispatch("getAttachableCategories");
      dispatch("deleteSelectedAttachablesFromState");
    });
};

const updateAttachable = (context, attachable) => {
  attachableApi.update(attachable).then(() => {});
};

const deleteSelectedAttachablesFromState = ({ commit, state, getters }) => {
  getters.selectedFromActiveCategory.forEach((attachable) => {
    commit("DELETE_ATTACHABLE_BY_ID", { id: attachable.id, category: attachable.attachable_category_hashed_id });
    commit("SET_SELECTED_ATTACHABLES", { id: state.activeCategoryId, attachables: [] });
  });
};

const getAttachableCategories = ({ state, commit, getters }) => {
  if (getters.hasCategory && state.isInstance === false) {
    commit("SET_LOADING_CATEGORIES", true);
    attachableCategoryApi
      .getForHasAttachableAndCategory(
        state.hasAttachableType,
        state.hasAttachableId,
        state.category,
      )
      .then((response) => {
        commit("SET_LOADING_CATEGORIES", false);
        commit("SET_ATTACHABLE_CATEGORIES", response.data);
      });
  } else {
    commit("SET_LOADING_CATEGORIES", true);
    attachableCategoryApi
      .getForHasAttachable(state.hasAttachableType, state.hasAttachableId)
      .then((response) => {
        commit("SET_LOADING_CATEGORIES", false);
        commit("SET_ATTACHABLE_CATEGORIES", response.data);
      });
  }
};
const updateAttachableName = (context, { id, name }) => {
  isAttachableApi.updateByAttachable(id, { name });
};
const createCategoryFromTemplate = ({ state, commit }, template) => {
  attachableCategoryApi.createFromTemplate(
    state.hasAttachableType,
    state.hasAttachableId,
    template.id,
  ).then((response) => {
    commit("UPDATE_CATEGORY", response.data);
  });
};
const getAttachablesForCategory = ({ state, commit }, attachableCategory) => {
  commit("SET_LOADED", false);

  if (!state.paginations[attachableCategory.id]) {
    state.paginations[attachableCategory.id] = {
      page: state.page,
      perPage: state.perPage,
      orderBy: state.orderBy,
      order: state.order,
      pagination: {},
    };
  }

  const pagination = state.paginations[attachableCategory.id];

  attachableCategoryApi.find(
    attachableCategory.id,
    [
      "attachable",
      "attachables.child_instance",
      "attachables.parent_instance",
    ],
    pagination.page,
    pagination.perPage,
    pagination.orderBy,
    pagination.order,
  ).then((response) => {
    commit("SET_ATTACHABLES", {
      categoryId: attachableCategory.id,
      attachables: response.data.attachables?.data,
    });

    commit("SET_PAGINATIONS", {
      categoryId: attachableCategory.id,
      pagination: {
        ...pagination,
        pagination: response.data.attachables?.meta.pagination,
      },
    });

    commit("SET_LOADED", true);
  });
};

const loadPage = (category) => {
  attachableCategoryApi.find(category.id, [
    "attachable",
    "attachables.child_instance",
    "attachables.parent_instance",
  ]).then(() => {
  });
};
export default {
  createCategoryFromTemplate,
  updateAttachable,
  updateAttachableName,
  getAttachableCategories,
  getAttachablesForCategory,
  deleteSelectedAttachablesFromState,
  deleteSelected,
  loadPage,
};
